import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

function PatientRegistration() {
  const { handleAPICall } = useAuth();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    dob: '',
    gender: '',
    contact: '',
    email: '',
    address: '',
    emergencyContact: '',
    facilityAttached: '',
    IDFromFacility: '',
    registration_date: '', 
    patient_type: '', 
    emergency_contact: '', 
    blood_type: '', 
    known_allergies: '',
    apiType: 'patientRegistration'
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateField = (name, value) => {
    switch(name) {
      case 'firstName':
      case 'lastName':
        return value.trim() ? '' : 'This field is required';
      case 'dob':
        return value ? '' : 'Date of birth is required';
      case 'gender':
        if(!value) return 'Gender is required';
        return '';
        case 'patient_type':
          if(!value) return 'Patient Type is required';
          return '';
      case 'email':
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? '' : 'Invalid email format';
      case 'contact':
      case 'emergency_contact':
        return /^[+]?[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/.test(value) ? '' : 'Invalid phone number';
      default:
        return '';
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if(errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const error = validateField(name, value);
    setErrors(prev => ({ ...prev, [name]: error }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    
    Object.keys(formData).forEach(name => {
      if(name === 'otherGender' && formData.gender !== 'Other') return;
      const error = validateField(name, formData[name]);
      if(error) newErrors[name] = error;
    });
  
    setErrors(newErrors);
    console.log("New Errors", newErrors);
    if(Object.keys(newErrors).length > 0) return;
    //alert("We Are Here");

    setIsSubmitting(true);
    try {
      const payload = {
        ...formData
      };
      
      const response = await handleAPICall(payload);
      alert(response.data.message);
      if(response.data.success){

      setFormData({
        firstName: '',
        lastName: '',
        dob: '',
        gender: '',
        contact: '',
        email: '',
        address: '',
        emergencyContact: '',
        facilityAttached: '',
        IDFromFacility: '',
        registration_date: '', 
        patient_type: '', 
        emergency_contact: '', 
        blood_type: '', 
        known_allergies: '',
        apiType: 'patientRegistration'      
      });
      
    }

      console.log("What Am getting From Backed", response.data);
    } catch (error) {
      console.error('Registration failed:', error);
    }
    setIsSubmitting(false);
  };

  const isFormValid = Object.keys(errors).every(key => !errors[key]) && 
    Object.keys(formData).every(key => {
      //alert(key)
     //if(key === 'otherGender') return formData.gender !== 'Other' || formData[key].trim();
      return key === 'emergency_contact' || key === 'blood_type' ? true : formData[key].trim();
    });

  return (
    <form 
      onSubmit={handleSubmit}
      className="p-5 bg-white rounded-4 shadow-lg mt-5"
      style={{ maxWidth: '', margin: '0 auto' }}
    >
      <h2 className="mb-5 text-primary text-center fw-bold">Patient Registration</h2>

      <div className="row g-4 mb-4">
        <div className="col-md-3">
          <div className="form-group">
            <label className="form-label text-muted mb-2">First Name *</label>
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              onBlur={handleBlur}
              className={`form-control border-bottom border-light py-2 px-0 ${errors.firstName ? 'is-invalid' : ''}`}
            />
            {errors.firstName && <div className="invalid-feedback d-block">{errors.firstName}</div>}
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Last Name *</label>
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              onBlur={handleBlur}
              className={`form-control border-bottom border-light py-2 px-0 ${errors.lastName ? 'is-invalid' : ''}`}
            />
            {errors.lastName && <div className="invalid-feedback d-block">{errors.lastName}</div>}
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Facility Attached *</label>
            <input
              type="text"
              name="facilityAttached"
              value={formData.facilityAttached}
              onChange={handleChange}
              onBlur={handleBlur}
              className={`form-control border-bottom border-light py-2 px-0 ${errors.facilityAttached ? 'is-invalid' : ''}`}
            />
            {errors.facilityAttached && <div className="invalid-feedback d-block">{errors.facilityAttached}</div>}
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-group">
            <label className="form-label text-muted mb-2">ID From The Facility *</label>
            <input
              type="text"
              name="IDFromFacility"
              value={formData.IDFromFacility}
              onChange={handleChange}
              onBlur={handleBlur}
              className={`form-control border-bottom border-light py-2 px-0 ${errors.IDFromFacility ? 'is-invalid' : ''}`}
            />
            {errors.IDFromFacility && <div className="invalid-feedback d-block">{errors.IDFromFacility}</div>}
          </div>
        </div>

        </div>

      <div className="row g-4 mb-4">
        <div className="col-md-3">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Date of Birth *</label>
            <input
              type="date"
              name="dob"
              value={formData.dob}
              onChange={handleChange}
              onBlur={handleBlur}
              className={`form-control border-bottom border-light py-2 px-0 ${errors.dob ? 'is-invalid' : ''}`}
            />
            {errors.dob && <div className="invalid-feedback d-block">{errors.dob}</div>}
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Gender *</label>
            <select
              name="gender"
              value={formData.gender}
              onChange={handleChange}
              onBlur={handleBlur}
              className={`form-select border-bottom border-light py-2 w-100 ${errors.gender ? 'is-invalid' : ''}`}
            >
              <option value="">Select Gender</option>
              <option>Female</option>
              <option>Male</option>
            </select>
            {errors.gender && <div className="invalid-feedback d-block">{errors.gender}</div>}
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Contact Number *</label>
            <input
              type="tel"
              name="contact"
              value={formData.contact}
              onChange={handleChange}
              onBlur={handleBlur}
              className={`form-control border-bottom border-light py-2 px-0 ${errors.contact ? 'is-invalid' : ''}`}
              placeholder="+1260977 000 000"
            />
            {errors.contact && <div className="invalid-feedback d-block">{errors.contact}</div>}
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Email Address *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              onBlur={handleBlur}
              className={`form-control border-bottom border-light py-2 px-0 ${errors.email ? 'is-invalid' : ''}`}
              placeholder="example@email.com"
            />
            {errors.email && <div className="invalid-feedback d-block">{errors.email}</div>}
          </div>
        </div>
      </div>

      <div className="row g-4 mb-4">
        <div className="col-md-3">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Registration Date *</label>
            <input
              type="date"
              name="registration_date"
              value={formData.registration_date}
              onChange={handleChange}
              onBlur={handleBlur}
              className={`form-control border-bottom border-light py-2 px-0 ${errors.registration_date ? 'is-invalid' : ''}`}
            />
            {errors.registration_date && <div className="invalid-feedback d-block">{errors.registration_date}</div>}
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Patient Type</label>
            <select
              name="patient_type"
              value={formData.patient_type}
              onChange={handleChange}
              onBlur={handleBlur}
              className={`form-select border-bottom border-light py-2 w-100 ${errors.patient_type ? 'is-invalid' : ''}`}
            >
              <option value="">Select Patient Type</option>
              <option>woman</option>
              <option>child</option>
            </select>
            {errors.patient_type && <div className="invalid-feedback d-block">{errors.patient_type}</div>}
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Emergency Phone Number *</label>
            <input
              type="tel"
              name="emergency_contact"
              value={formData.emergency_contact}
              onChange={handleChange}
              onBlur={handleBlur}
              className={`form-control border-bottom border-light py-2 px-0 ${errors.emergency_contact ? 'is-invalid' : ''}`}
              placeholder="+1260977 000 000"
            />
            {errors.emergency_contact && <div className="invalid-feedback d-block">{errors.emergency_contact}</div>}
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Blood Type</label>
            <select
              name="blood_type"
              value={formData.blood_type}
              onChange={handleChange}
              onBlur={handleBlur}
              className={`form-select border-bottom border-light py-2 w-100 ${errors.blood_type ? 'is-invalid' : ''}`}
            >
              <option value="">Select Blood Type</option>
              <option>A</option>
              <option>A+</option>
              <option>B</option>
              <option>O</option>
              <option>O+</option>
            </select>
            {errors.blood_type && <div className="invalid-feedback d-block">{errors.blood_type}</div>}
          </div>
        </div>
      </div>

      <div className="row g-4 mb-1">
        <div className="col-md-6 mb-2">
        <div className="form-group">
          <label className="form-label text-muted mb-2">Known Allergies</label>
          <textarea
            name="known_allergies"
            value={formData.known_allergies}
            onChange={handleChange}
            className="form-control bg-light border-0 rounded-3 p-3"
            rows="4"
            placeholder="Enter information about any known allergies..."
          ></textarea>
        </div>
      </div>

      <div className="col-md-6 mb-2">
        <div className="form-group">
          <label className="form-label text-muted mb-2">Address</label>
          <textarea
            name="address"
            value={formData.address}
            onChange={handleChange}
            className="form-control bg-light border-0 rounded-3 p-3"
            rows="4"
            placeholder="Enter your address..."
          ></textarea>
        </div>
      </div>

      </div>

      <div className="d-grid mt-5">
        <button 
          type="submit"
          className="btn btn-primary btn-lg py-3 fw-bold hover-effect w-100"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Registering...' : 'Register Patient'}
        </button>
      </div>
    </form>
  );
}

export default PatientRegistration;